<template>
  <div class="nsaleBs_">
    <div class="form_ content_">
      <div class="input_">
        <div class="text_">用户名称：</div>
        <cube-input class="logStyle" placeholder="请输入用户名称"></cube-input>
      </div>

      <div class="input_">
        <div class="text_">联系人：</div>
        <cube-input class="logStyle" placeholder="联系人"></cube-input>
      </div>

      <div class="input_">
        <div class="text_">电子邮箱：</div>
        <cube-input class="logStyle" placeholder="电子邮箱"></cube-input>
      </div>

      <div class="input_">
        <div class="text_">所属行业：</div>
        <div class="input_c" @click="showPicker3">
          <div class=" text_1">{{ form.hangye | filterAll(column3) }}</div>
          <div class="arrow"></div>
        </div>
      </div>

      <div class="input_">
        <div class="text_">所属城市：</div>
        <div class="input_c" @click="showPicker4">
          <div class=" text_1">{{ form.city | filterAll(column4) }}</div>
          <div class="arrow"></div>
        </div>
      </div>

      <div class="input_">
        <div class="text_">详细地址：</div>
        <cube-input
          class="logStyle"
          placeholder="请输入详细地址（选填）"
        ></cube-input>
      </div>

      <div class="input_">
        <div class="text_">真实姓名：</div>
        <cube-input class="logStyle" placeholder="请输入真实姓名"></cube-input>
      </div>

      <div class="input_">
        <div class="text_">证件类型：</div>
        <div class="input_c" @click="showPicker7">
          <div class=" text_1">{{ form.idType | filterAll(column7) }}</div>
          <div class="arrow"></div>
        </div>
      </div>

      <div class="input_">
        <div class="text_">证件号码：</div>
        <cube-input class="logStyle" placeholder="请输入证件号码"></cube-input>
      </div>

      <Upload :type="form.idType" />

      <div class="Btn_">
        确认
      </div>
      <!--  -->
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import moment from "moment";
const column3 = [
  { text: "保险/金融", value: "1" },
  { text: "互联wang", value: "2" }
];
const column4 = [{ text: "上海", value: "1" }, { text: "苏州", value: "2" }];
const column7 = [{ text: "身份证", value: "1" }, { text: "护照", value: "2" },{ text: '其他', value: '08' }];

export default {
  data() {
    return {
      column3,
      column4,
      column7,
      form: {
        hangye: "",
        city: "",
        idType: "1"
      }
    };
  },
  filters: {
    filterAll(val, list) {
      let v = null;
      list.map(item => {
        if (item.value == val) {
          v = item.text;
        }
      });

      if (v) {
        return v;
      } else {
        return "请选择";
      }
    }
  },
  mounted() {},
  methods: {
    showPicker3() {
      if (!this.picker3) {
        this.picker3 = this.$createPicker({
          title: "选择",
          data: [column3],
          onSelect: this.selectHandle3
        });
      }
      this.picker3.show();
    },
    selectHandle3(selectedVal, selectedIndex, selectedText) {
      this.form.hangye = selectedVal[0];
    },

    showPicker4() {
      if (!this.picker4) {
        this.picker4 = this.$createPicker({
          title: "选择",
          data: [this.column4],
          onSelect: this.selectHandle4
        });
      }
      this.picker4.show();
    },
    selectHandle4(selectedVal, selectedIndex, selectedText) {
      this.form.city = selectedVal[0];
      console.log(this.form);
    },

    showPicker7() {
      if (!this.picker7) {
        this.picker7 = this.$createPicker({
          title: "选择",
          data: [this.column7],
          onSelect: this.selectHandle7
        });
      }
      this.picker7.show();
    },
    selectHandle7(selectedVal, selectedIndex, selectedText) {
      this.form.idType = selectedVal[0];
    }
  }
};
</script>

<style lang="scss" scoped>
.nsaleBs_ {
  padding: 25px;
  min-height: 100vh;
  font-size: 15px;
  .content_ {
    // padding: 0 25px;
    border-radius: 5px;
    .input_ {
      width: 100%;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f7f7f7;
      padding: 5px 0;
      position: relative;
      .text_ {
        color: rgba(51, 51, 51, 1);
        width: 100px;
        text-align: left;
        height: 40px;
        line-height: 40px;
      }
      .text_1 {
        font-size: 15px;
        color: rgba(20, 35, 75, 1);
        margin-right: 10px;
        height: 40px;
        line-height: 40px;
      }
      .img_ {
        height: 13px;
        width: auto;
      }
      .logStyle {
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 600;
        color: rgba(204, 204, 204, 1);
        height: 36px;
        border-radius: 18px;
        background: none;
        display: flex;
      }
      .input_c {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .verCode_ {
        position: absolute;
        top: 33%;
        right: 0;
        font-size: 15px;
        color: rgba(255, 74, 53, 1);
      }
    }
  }
  .Btn_ {
    width: 324px;
    height: 50px;
    line-height: 50px;
    background: rgba(255, 74, 53, 1);
    border-radius: 5px;
    color: rgba(255, 255, 255, 1);
  }
}

.arrow {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid rgba(0, 0, 0, 1);
}

.cube-input::after {
  border: none;
}
</style>
